import { render, staticRenderFns } from "./deleteFeeRule.vue?vue&type=template&id=73f8accc&scoped=true"
import script from "./deleteFeeRule.vue?vue&type=script&lang=js"
export * from "./deleteFeeRule.vue?vue&type=script&lang=js"
import style0 from "./deleteFeeRule.vue?vue&type=style&index=0&id=73f8accc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f8accc",
  null
  
)

export default component.exports